function getUuid(): string {

  const cryptoObj = window.crypto || (window as any).msCrypto // for IE 11

  // Uses the crypto API to generate a RFC4122 version 4 compliant solution for a unique ID
  // Taken from: https://stackoverflow.com/a/2117523
  return ([1e7] as any + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )

}

export default {
  getUuid
}
